import type { ReactNode } from 'react'

export function OrderDetailSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section>
      <OrderSectionHeading title={title} />
      {children}
    </section>
  )
}

export function OrderSectionHeading({ title }: { title: string }) {
  return (
    <h2 className="text-content mb-4 flex items-center gap-2 text-base font-semibold">
      <span aria-hidden className="bg-accent size-2 rounded-full shadow-[0_0_0_0.25rem_var(--accent-soft)]" />
      {title}
    </h2>
  )
}
